import { createContext, useContext, useEffect, useState } from "react";
import api, { friendlyAxiosError } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = loading, false = not authenticated, object = user
  const [error, setError] = useState("");

  const fetchMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      setUser(false);
      return null;
    }
  };

  useEffect(() => {
    // Ritorno da Google Auth: lo scambio del session_id è gestito da AuthCallback.
    if (window.location.hash?.includes("session_id=")) { setUser(false); return; }
    fetchMe();
  }, []);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.access_token) localStorage.setItem("access_token", data.access_token);
      await fetchMe();
      return true;
    } catch (e) {
      setError(friendlyAxiosError(e));
      return false;
    }
  };

  const register = async (name, email, password, qualifica, invite_token) => {
    setError("");
    try {
      const body = { name, email, password, qualifica };
      if (invite_token) body.invite_token = invite_token;
      const { data } = await api.post("/auth/register", body);
      if (data.access_token) localStorage.setItem("access_token", data.access_token);
      await fetchMe();
      return true;
    } catch (e) {
      setError(friendlyAxiosError(e));
      return false;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("access_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, error, setError, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
